import useGetter from "./useGetter";
import useLeagueSeason from "./useLeagueSeason";
import useWeek from "./useWeek";

export default function useWaiversPlayers() {
  const { leagueSeason } = useLeagueSeason();
  const { currentWeek } = useWeek();

  let leagueId = null;
  let season = null;
  if (leagueSeason) {
    leagueId = leagueSeason.obj.league;
    season = leagueSeason.obj.season;
  }

  const waiversPlayersUrl = `/rosters/${leagueId}/${season}/${currentWeek}/waivers`;

  const enabled = !!leagueSeason;
  const { data: waiversPlayersData, query: waiversPlayersQuery } = useGetter(
    waiversPlayersUrl,
    {
      enabled,
    }
  );

  return { waiversPlayersData, waiversPlayersQuery, waiversPlayersUrl };
}
